export default {
    "title": "Storage",
    "entityName": "storage",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "address",
            "text": "Address",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": false
            },
            render: item => `${item.address}, ${item.city}, ${item.cap} (${item.country})`,
            "validators": [
                "required"
            ]
        },
        {
            "value": "cap",
            "text": "Cap",
            "type": "text",
            "validators": [
                "required",
            ]
        },
        {
            "value": "city",
            "text": "City",
            "type": "text",
            "validators": [
                "required"
            ]
        },
        {
            "value": "country",
            "text": "Country",
            "type": "text",
            "validators": [
                "required",
                (field, value) => value.length <= 2 || `Country max. length is 2` 
            ]
        },
        {
            "value": "online_response",
            "text": "Online response",
            "type": "check",
            "table": {
                "sortable": true,
                "filter": true
            }
        }
    ],
    "actions": [ 
        "upsert", "remove",
        { "value": "references", "text": "References", "color": "primary", "icon": "mdi-contacts" },
        'audit'
    ],
}